<template>
  <div class="survey-information-container">
    <survey-info-circle :color="type === 'success' ? '#006d36' : '#00366D'">
      <img v-if="type === 'completed'" src="@/assets/data_check_28dp_00366D.svg" alt="" class="inner-circle-icon" />
      <v-icon v-else-if="type === 'inactive'" color="#00366D" size="28">group_off</v-icon>
      <v-icon v-else-if="type === 'not-found' || type === 'finalized' || type === 'scheduled'" color="#00366D" size="28">error_outline</v-icon>
      <v-icon v-else-if="type === 'success'" color="#006d36" size="28">check_circle</v-icon>
      <v-icon v-else-if="type === 'unauthorized'" color="#00366D" size="28">group_off</v-icon>
    </survey-info-circle>
    <div class="text-container">
      <span class="survey-information-title">{{ title }}</span>
      <span class="survey-information-subtitle">{{ subtitle }}</span>
    </div>

    <v-btn
      v-if="type === 'unauthorized' || type === 'completed'"
      class="mt-3"
      elevation="1"
      :color="assets.colors.form.buttonBackground"
      :style="{ color: assets.colors.form.buttonFont }"
      @click="goBack"
    >
      <v-icon left dark> mdi-arrow-left </v-icon>
      <span>Voltar</span>
    </v-btn>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import SurveyInfoCircle from '../components/SurveyInfoCircle.vue'

export default {
  name: 'SurveyInformation',
  components: {
    SurveyInfoCircle
  },
  props: {
    type: {
      type: String,
      required: true,
      validator: value => ['inactive', 'completed', 'unauthorized', 'not-found', 'success', 'finalized', 'scheduled'].includes(value)
    }
  },
  computed: {
    ...mapGetters(['GET_ASSETS']),
    assets() {
      return this.GET_ASSETS
    },
    title() {
      switch (this.type) {
        case 'completed':
          return 'Sua resposta já foi registrada!'
        case 'inactive':
          return 'Pesquisa inativa'
        case 'finalized':
          return 'Pesquisa encerrada'
        case 'scheduled':
          return 'Pesquisa agendada'
        case 'unauthorized':
          return 'Pesquisa indisponível para o seu perfil'
        case 'not-found':
          return 'Pesquisa não encontrada'
        case 'success':
          return 'Respostas enviadas!'
        default:
          return ''
      }
    },
    subtitle() {
      switch (this.type) {
        case 'completed':
          return 'Nossos registros mostram que você já respondeu a esta pesquisa anteriormente. Não se preocupe, suas respostas estão salvas com a gente. Muito obrigado por participar!'
        case 'inactive':
          return 'Esta pesquisa está inativa.'
        case 'finalized':
          return 'Esta pesquisa foi encerrada.'
        case 'scheduled':
          return 'Esta pesquisa ainda não foi iniciada.'
        case 'unauthorized':
          return 'Agradecemos seu interesse, mas esta ação é direcionada a outro grupo de consumidores. Continue comprando conosco para participar das próximas!'
        case 'not-found':
          return 'Esta pesquisa não foi encontrada.'
        case 'success':
          return 'Suas respostas foram registradas na nossa base de dados. Muito obrigado por participar!'
        default:
          return ''
      }
    }
  },
  methods: {
    goBack() {
      this.$router.back()
    }
  }
}
</script>

<style scoped lang="scss">
.survey-information-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  margin-top: 182px;

  @media screen and (max-width: 768px) {
    margin-top: 70px;
  }

  .inner-circle-icon {
    width: 28.54px;
    height: 27.3px;
  }

  .text-container {
    padding: 20px;
    padding-top: 0;
    width: 846px;
    text-align: center;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 12px;
    margin-top: -38px;

    @media screen and (max-width: 768px) {
      width: 100%;
    }
  }

  .survey-information-title {
    font-weight: bold;
    font-size: 22px;
    text-align: center;
    color: #4b525a;
  }

  .survey-information-subtitle {
    font-weight: 400;
    font-size: 16px;
    text-align: center;
    color: #4b525a;
  }
}
</style>
